type Listener = (nodeId: string, removed: boolean) => void;

const listeners = new Set<Listener>();

export function onNodeImageChanged(listener: Listener): () => void {
	listeners.add(listener);
	return () => listeners.delete(listener);
}

export function emitNodeImageChanged(nodeId: string, removed = false) {
	for (const listener of listeners) {
		listener(nodeId, removed);
	}
}
